var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-components"},[_c('ContentNotify'),_c('Loading'),_c('CurrentPopup'),_c('CurrentActionSheet')],1)}
var staticRenderFns = []

export { render, staticRenderFns }